import styled from "styled-components";

import { SPACING } from "../../../utils/constants";
import {
  DisclosurePanel,
  DisclosureToggle as BaseDisclosureToggle,
} from "../../Disclosure/styles";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
`;

export const ErrorMessage = styled.span`
  font-size: var(--text-sm);
  color: var(--color-error);
`;

/**
 * Advisory, not a failure: the field itself is valid, the buy just isn't
 * viable yet. Shares the warning token with `NoPriceBadge` so the inline
 * notice and the option badge read as the same signal.
 */
export const WarningMessage = styled.span`
  font-size: var(--text-sm);
  color: var(--color-warning);
`;

export const OptionRow = styled.span`
  display: flex;
  align-items: baseline;
  gap: ${SPACING.xs}px;
  flex-wrap: wrap;
`;

export const OptionSymbol = styled.span`
  font-weight: 600;
`;

export const OptionMeta = styled.span`
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
`;

/** Warns that a buy against this ticker will be rejected until it is priced. */
export const NoPriceBadge = styled.span`
  font-size: var(--text-xs);
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: ${SPACING.xxs}px ${SPACING.xs}px;
  border-radius: 999px;
  border: 1px solid var(--color-warning-border);
  color: var(--color-warning);
`;

export const DisclosureToggle = styled(BaseDisclosureToggle)`
  align-self: flex-start;
`;

export const Disclosure = styled(DisclosurePanel)`
  display: flex;
  flex-direction: column;
`;

export const DisclosureTitle = styled.span`
  font-size: var(--text-xs);
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-secondary);
`;

export const DisclosureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${SPACING.sm}px;
`;

export const DisclosureField = styled.label`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xxs}px;
  font-size: var(--text-xs);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--color-text-secondary);
`;

export const DisclosureInput = styled.input`
  height: 28px;
  padding: 0 ${SPACING.sm}px;
  border-radius: 0.5rem;
  border: 1px solid var(--color-gray-border);
  background: var(--color-card-background);
  color: var(--color-select-text);
  font-size: var(--text-base);
  font-weight: 500;
`;

export const DisclosureSelect = styled.select`
  height: 28px;
  padding: 0 ${SPACING.xs}px;
  border-radius: 0.5rem;
  border: 1px solid var(--color-gray-border);
  background: var(--color-card-background);
  color: var(--color-select-text);
  font-size: var(--text-base);
  font-weight: 500;
`;

export const DisclosureHelper = styled.span`
  font-size: var(--text-sm);
  font-style: italic;
  color: var(--color-text-secondary);
`;

export const DisclosureTextArea = styled.textarea`
  padding: ${SPACING.xs}px ${SPACING.sm}px;
  border-radius: 0.5rem;
  border: 1px solid var(--color-gray-border);
  background: var(--color-card-background);
  color: var(--color-select-text);
  font-family: inherit;
  font-size: var(--text-base);
  font-weight: 500;
  resize: vertical;
`;

export const SuccessMessage = styled.span`
  font-size: var(--text-sm);
  color: var(--color-success);
`;
